import { render, staticRenderFns } from "./ProjectsTableExpansion.vue?vue&type=template&id=5f80f255&scoped=true&"
import script from "./ProjectsTableExpansion.vue?vue&type=script&lang=js&"
export * from "./ProjectsTableExpansion.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsTableExpansion.vue?vue&type=style&index=0&id=5f80f255&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f80f255",
  null
  
)

export default component.exports